import { lazy, Suspense } from 'react'
import { Routes, Route, BrowserRouter } from 'react-router-dom'
import PrivateRoutes from './PrivateRoutes'

import Login from '../pages/Login'
import CustomerDetails from '../pages/CustomerDetails'
import NewReturningAnalysisList from '../pages/Reports/ConsolidatedReports/views/NewRetAnalysisList'

// Home Routes
const OfflineHome = lazy(() => import('../pages/Home/index'))
const CumulativeData = lazy(() => import('../pages/CumulativeData'))
const ProductProfilingPage = lazy(() => import('../pages/ProductProfiling'))
const LoyaltyPage = lazy(() => import('../pages/Loyalty'))
const Discount = lazy(() => import('../pages/Discount/index'))
const Offers = lazy(() => import('../pages/Offers/index'))
const LoyaltyLevel = lazy(() => import('../pages/LoyaltyLevel/index'))
const LoyaltyOffers = lazy(() => import('../pages/LoyaltyOffers/index'))

// Campaign Route
const CampaignMenuList = lazy(() => import('../pages/Campaign/index'))
const CustomersCampaign = lazy(() => import('../pages/Campaign/Views/DataBankCampaign/index'))
const ProductsCampaign = lazy(() => import('../pages/Campaign/Views/ProductsCampaign/index'))
const CRMCampaign = lazy(() => import('../pages/Campaign/Views/CRMCampaign/index'))
const WhatsappSubscribedCustomer = lazy(() =>
  import('../pages/Campaign/Views/WhatsappSubscribedCustomer/index'),
)
const CampaignMonitoring = lazy(() => import('../pages/Campaign/Views/CampaignMonitoring/index'))
const RecentCampaigns = lazy(() => import('../pages/Campaign/Views/RecentCampaigns/index'))
const CampaignAnalysis = lazy(() => import('../pages/Campaign/Views/CampaignAnalysis/index'))
const CampaignPredective = lazy(() => import('../pages/Campaign/Views/CampaignPredective/index'))
const CustomerClustering = lazy(() => import('../pages/Campaign/Views/CustomerClustering/index'))
const CustomerInsights = lazy(() => import('../pages/Campaign/Views/CustomerInsights/index'))
const CohortAnalysis = lazy(() => import('../pages/Campaign/Views/CohortAnalysis/index'))
const CohortCampaignPlaning = lazy(() =>
  import('../pages/Campaign/Views/CohortCampaignPlaning/index'),
)
const ConditionBasedCampaign = lazy(() =>
  import('../pages/Campaign/Views/ConditionBasedCampaign/index'),
)
const CustomerSegmentation = lazy(() =>
  import('../pages/Campaign/Views/CustomerSegmentation/index'),
)

// Synopsis Routes
const SynopsisMenuList = lazy(() => import('../pages/Synopsis/index'))
const CustomersSegmentation = lazy(() => import('../pages/Synopsis/Views/CustomersSegmentation'))
const SegmentTransition = lazy(() => import('../pages/Synopsis/Views/SegmentTransition'))
const CrossCampaignAnalytics = lazy(() => import('../pages/Synopsis/Views/CrossCampaignAnalytics'))
const ConversionAnalysis = lazy(() => import('../pages/Synopsis/Views/ConversionAnalysis'))
// const CampaignAnalysis = lazy(() => import('../pages/Synopsis/Views/CampaignAnalysis'))
const CustomersResponseAnalysis = lazy(() =>
  import('../pages/Synopsis/Views/CustomersResponseAnalysis'),
)
const WeatherCharts = lazy(() => import('../pages/Synopsis/Views/WeatherAnalysis'))
const StoresPerformances = lazy(() => import('../pages/Synopsis/Views/StoresPerformances'))
const RfmAnalysis = lazy(() => import('../pages/Synopsis/Views/RfmAnalysis'))

const LoadingIcon = lazy(() => import('../components/UI/LoadingIcon'))
// const SetUpFacebookCampagin = lazy(() => import('../pages/SetUpFacebookCampagin'))
const UserDetails = lazy(() => import('../pages/UserDetails'))
const Promotions = lazy(() => import('../pages/Promotions/index'))
const ProductDetailing = lazy(() => import('../pages/ProductDetailing'))
const ModeSelection = lazy(() => import('../pages/ModeSelection'))
const CurrentDomModal = lazy(() => import('../components/modal/CurrentDomModal'))

// Sync routes
const SyncOverview = lazy(() => import('../pages/SyncOverview/syncOverview'))

// Report routes
const Reports = lazy(() => import('../pages/Reports/index'))
const AppUsers = lazy(() => import('../pages/App/index.js'))
const CustomizeReport = lazy(() => import('../pages/Reports/CustomizeReport'))
const ShopWiseReportList = lazy(() =>
  import('../pages/Reports/ConsolidatedReports/views/ShopwiseAnalysisList'),
)
const TimeWiseReportList = lazy(() =>
  import('../pages/Reports/ConsolidatedReports/views/TimeWiseAnalysisList'),
)
const DayWiseReportList = lazy(() =>
  import('../pages/Reports/ConsolidatedReports/views/DaywiseAnalysisList'),
)
const CategoryWiseReportList = lazy(() =>
  import('../pages/Reports/ConsolidatedReports/views/CategorywiseAnalysisList'),
)
const InclusionAnalysisList = lazy(() =>
  import('../pages/Reports/ConsolidatedReports/views/InclusionAnalysis'),
)
// Actionable routes
const Actionable = lazy(() => import('../pages/Actionable'))

// Settings routes
const Settings = lazy(() => import('../pages/Settings/index'))

// Feedback Routes
const FeedbackPage = lazy(() => import('../pages/FeedbackLandingPage/index'))
const FeedbackDetails = lazy(() => import('../pages/Feedback/views/Feedback'))
const FeedbackAnalytics = lazy(() => import('../pages/Feedback/views/FeedbackAnalytics'))
const FeedbackQuestions = lazy(() => import('../pages/Feedback/views/FeedbackQuestions'))

// CDB
const Cdb = lazy(() => import('../pages/cdb'))
const Ai = lazy(() => import('../pages/Ai'))
const LevisLoyalty = lazy(() => import('../pages/LevisLoyalty'))

const Routers = () => {
  return (
    <Suspense fallback={<LoadingIcon />}>
      <BrowserRouter>
        <Routes>
          <Route path='/login' element={<Login />} />

          <Route path='/modal' element={<CurrentDomModal />} />
          <Route element={<PrivateRoutes />}>
            <Route path='/' element={<ModeSelection />} />
            <Route path='/home' element={<OfflineHome />} />
            <Route path='/cumulative-data' element={<CumulativeData />} />
            <Route path='/product-profiling' element={<ProductProfilingPage />} />
            <Route path='/loyalty' element={<LoyaltyPage />} />
            <Route path='/synopsis-list' element={<SynopsisMenuList />} />
            <Route path='/campaign-list' element={<CampaignMenuList />} />

            {/* <Route path='/' element={mode === 'online' ? <Home /> : <OfflineHome />} /> */}

            {/* Campaigns Route */}
            <Route path='/data-bank-campaigns' element={<CustomersCampaign />} />
            <Route path='/products-campaigns' element={<ProductsCampaign />} />
            <Route path='/crm-campaigns' element={<CRMCampaign />} />
            <Route
              path='/subscribed-customers-campaigns'
              element={<WhatsappSubscribedCustomer />}
            />
            <Route path='/campaign-monitoring' element={<CampaignMonitoring />} />
            <Route path='/recent-campaigns' element={<RecentCampaigns />} />
            <Route path='/campaign-analysis' element={<CampaignAnalysis />} />
            <Route path='/predictive-campaigns' element={<CampaignPredective />} />
            <Route path='/cluster-based-campaigns' element={<CustomerClustering />} />
            <Route path='/insights-based-campaigns' element={<CustomerInsights />} />
            <Route path='/segmentation-based-campaigns' element={<CustomerSegmentation />} />
            <Route path='/cohort-analysis-campaigns' element={<CohortAnalysis />} />
            <Route path='/cohort-campaign-planning' element={<CohortCampaignPlaning />} />
            <Route path='/condition-based-campaign' element={<ConditionBasedCampaign />} />
            {/* Feedback */}
            <Route path='/feedback' element={<FeedbackPage />} />
            <Route path='/feedbackdetails/:mobile' element={<FeedbackDetails />} />
            <Route path='/feedbackanalytics' element={<FeedbackAnalytics />} />
            <Route path='/feedbackquestion' element={<FeedbackQuestions />} />
            {/* CustomizeReport */}
            <Route path='/reports' element={<Reports />} />
            <Route path='/shopwise-analysis' element={<ShopWiseReportList />} />
            <Route path='/daywise-analysis' element={<DayWiseReportList />} />
            <Route path='/timewise-analysis' element={<TimeWiseReportList />} />
            <Route path='/customize-report' element={<CustomizeReport />} />
            <Route path='/categorywise-analysis' element={<CategoryWiseReportList />} />
            <Route path='/newreturning-analysis' element={<NewReturningAnalysisList />} />
            <Route path='/inclusion-analysis' element={<InclusionAnalysisList />} />
            {/* Actionable */}
            <Route path='/actionable' element={<Actionable />} />
            {/* <Route path='/setup-facebook-campagin' element={<SetUpFacebookCampagin />} /> */}
            <Route path='/settings' element={<Settings />} />
            <Route path='/user-details/:id' element={<UserDetails />} />
            <Route path='/customer-details/:mobile' element={<CustomerDetails />} />
            <Route path='/discount' element={<Discount />} />
            <Route path='/loyalty-levels' element={<LoyaltyLevel />} />
            <Route path='/loyalty-offers' element={<LoyaltyOffers />} />
            <Route path='/offers' element={<Offers />} />
            <Route path='/promotions' element={<Promotions />} />
            <Route path='/product/:code' element={<ProductDetailing />} />
            <Route path='/CustomersSegmentation' element={<CustomersSegmentation />} />
            <Route path='/SegmentTransition' element={<SegmentTransition />} />
            <Route path='/CrossCampaignAnalytics' element={<CrossCampaignAnalytics />} />
            <Route path='/ConversionAnalysis' element={<ConversionAnalysis />} />
            <Route path='/CampaignAnalysis' element={<CampaignAnalysis />} />
            <Route path='/CustomersResponseAnalysis' element={<CustomersResponseAnalysis />} />
            <Route path='/StoresPerformances' element={<StoresPerformances />} />
            <Route path='/rfm-analysis' element={<RfmAnalysis />} />
            <Route path='/weather-analysis' element={<WeatherCharts />} />
            <Route path='/sync' element={<SyncOverview />} />

            <Route path='/cdb' element={<Cdb />} />
            <Route path='/ai' element={<Ai />} />
            <Route path='/user-loyalties' element={<LevisLoyalty />} />

            {/* App Users */}
            <Route path='/app' element={<AppUsers />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </Suspense>
  )
}

export default Routers
